<template>
  <div>
    <h3 class="heading-3 mb-12">
      {{ question.title }}
    </h3>

    <component
      :is="question.info.tag"
      v-if="question.showInfo"
      :class="[
        'mt-12',
        'mb-16',
        {
          'body-2 list-none': question.info.tag === 'ul',
        },
      ]"
    >
      <component
        :is="question.info.subTag"
        v-for="text in question.info.text"
        :key="text"
        class="flex gap-12"
      >
        <IconCheckSmall class="shrink-0" />
        {{ text }}
      </component>
    </component>

    <RevInputSelect
      v-if="question.isSelect"
      :id="question.key"
      class="mt-8"
      :data-qa="question.key"
      :label="question.placeholder || ''"
      :model-value="question.value !== false ? question.value : ''"
      :options="question.options"
      @update:model-value="
        (val) =>
          emit('answer', question.key, typeof val === 'string' ? val : '')
      "
    />

    <QuestionsFormRadioInput
      v-if="question.isRadio"
      :question
      :radio-model="question.value"
      @answer="(key, value) => emit('answer', key, value)"
    />

    <div
      v-if="question.infoBlock"
      class="text-action-default-low body-2 my-8 flex flex-col gap-8"
    >
      <p v-for="text in question.infoBlock.paragraphs" :key="text">
        {{ text }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RevInputSelect } from '@ds/components/InputSelect'
import { IconCheckSmall } from '@ds/icons/IconCheckSmall'

import type { RenderQuestion } from '~/scopes/buyback/composables/useFunnelQuestions'

import QuestionsFormRadioInput from './QuestionsFormRadioInput.vue'

defineProps<{
  question: RenderQuestion
}>()

const emit = defineEmits<{
  (event: 'answer', key: string, value: string | false): void
}>()
</script>
